/*
 *   File : admin-detail.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../../Components/Cta";
import { Chip, CustomTab, Loader } from "../../Components/Other";
import Overview from "./Helper/overview";
import Users from "./Helper/users";
import Transactions from "./Helper/transactions";
import { useParams } from "react-router-dom";
import { APIService } from "../../Service";
import { ConfirmationModal } from "../../Components/Modals";
import { toast } from "react-toastify";

const TAB_DATA = [
  {
    id: 1,
    label: "Overview",
    name: "overview",
  },
  {
    id: 2,
    label: "Users",
    name: "users",
  },
  {
    id: 3,
    label: "Orders",
    name: "orders",
  },
];

export default function AdminDetail() {
  const { id } = useParams();
  const [tab, setTab] = useState(1);
  const [loading, setLoading] = useState(false);
  const [adminDetails, setAdminDetails] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    _getAdminDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //service to get admin details
  const _getAdminDetails = () => {
    const is_post = true;
    const payload = {
      id: id,
    };
    APIService(is_post, "sub-admin/details", payload)
      .then((response) => {
        if (response.status_code === 200) {
          // console.log(response.data?.dashboard);
          setAdminDetails(response.data);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //service to block/unblock user
  const _blockUser = (id) => {
    const is_post = true;
    const payload = {
      id: id,
    };
    APIService(is_post, "sub-admin/block", payload)
      .then((response) => {
        if (response.status_code === 200) {
          setShowModal(false);
          toast.success(response.message);
          _getAdminDetails();
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const _handleTabChange = (id) => {
    setTab(id);
  };

  return loading ? (
    <div className="d-flex min-vh-100 align-items-center justify-content-center">
      <Loader width={30} />
    </div>
  ) : (
    <div className="row px-3 e-pt-20px">
      <div className="col-12 e-sidebar-nav-gradient e-border-radius-16 p-3">
        {/* Header section */}
        <div className="d-flex column-gap-2">
          <div className="d-flex flex-column text-white e-w-fit">
            <p className="e-primary-font-poppins e-text-magnolia e-font-weight-400 e-font-12 text-uppercase">
              NAME
            </p>
            <h5 className="e-font-18 e-primary-font-poppins e-font-weight-500 text-capitalize">
              {adminDetails?.admin_data?.admin_name}
            </h5>
          </div>

          <div className="ms-auto e-w-fit">
            <div className="d-flex align-items-center justify-content-end">
              <PrimaryButton
                onPress={() => setShowModal(true)}
                icon="block"
                ClassName="e-text-begonia bg-transparent e-border-radius-pill e-border-1px-begonia py-2"
                size="16px"
                name={
                  adminDetails?.admin_data?.status === "Active"
                    ? "Block Sub Admin"
                    : "UnBlock Sub Admin"
                }
              />
            </div>
          </div>
        </div>

        {/* Card section */}
        <div className="d-flex pt-3 column-gap-2 row-gap-2 flex-wrap">
          {/* Amount invested */}
          <div className="e-w-fit">
            <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px  ps-3 e-pe-64px  e-border-radius-8">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="e-font-12 e-font-weight-500 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                  RM Code
                </h4>
              </div>
              <div>
                <p className="e-font-18 e-text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                  {adminDetails?.admin_data?.rm_code}
                </p>
              </div>
            </div>
          </div>
          <div className="e-w-fit">
            <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px  ps-3 e-pe-64px  e-border-radius-8">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="e-font-12 e-font-weight-500 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                  Mail
                </h4>
              </div>
              <div>
                <p className="e-font-18 e-text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                  {adminDetails?.admin_data?.admin_email}
                </p>
              </div>
            </div>
          </div>
          <div className="e-w-fit">
            <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px  ps-3 e-pe-64px  e-border-radius-8">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="e-font-12 e-font-weight-500 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                  Phone no:
                </h4>
              </div>
              <div>
                <p className="e-font-18 e-text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                  {adminDetails?.admin_data?.phone_number}
                </p>
              </div>
            </div>
          </div>
          <div className="e-w-fit">
            <div className="d-flex h-100 flex-column justify-content-between e-bg-magnolia e-py-20px  ps-3 e-pe-64px  e-border-radius-8">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="e-font-12 e-font-weight-500 e-text-black text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                  Created on
                </h4>
              </div>
              <div>
                <p className="e-font-18 e-text-black e-font-weight-600 e-secondary-font-Inter p-0 m-0">
                  {adminDetails?.admin_data?.created}
                </p>
              </div>
            </div>
          </div>
          {/* Chip card */}
          <div className="e-w-fit">
            <div className="d-flex flex-column e-bg-magnolia e-py-20px ps-3 e-pe-64px  e-border-radius-8">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="e-text-black e-font-12 e-font-weight-500 text-uppercase e-primary-font-poppins line-height-20px letter-spacing-0-5px">
                  user status
                </h4>
              </div>
              <div className="e-w-fit">
                {adminDetails?.admin_data?.status === "Active" ? (
                  <Chip
                    label="Active"
                    fontWeight="e-font-weight-500"
                    borderColor="e-border-1px-green"
                    bgColor="e-bg-pale-green"
                    fontColor="e-text-green"
                  />
                ) : (
                  <Chip
                    label="Blocked"
                    fontWeight="e-font-weight-500"
                    borderColor="e-border-1px-ruby"
                    bgColor="e-bg-pale-ruby"
                    fontColor="e-text-ruby"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* switch tabs */}
      <div className="e-customer-tab d-flex flex-nowrap e-border-1px-bottom-magnolia-light e-pt-36px">
        {TAB_DATA.map((data, index) => (
          <CustomTab
            key={index}
            type={1}
            borderRadius="border-radius-4"
            tabData={data}
            tabIndex={tab}
            background="bg-white"
            handleChange={() => _handleTabChange(data.id)}
          />
        ))}
      </div>

      {tab === 1 ? (
        <Overview dashboard={adminDetails?.dashboard} loading={loading} />
      ) : tab === 2 ? (
        <Users id={id} />
      ) : tab === 3 ? (
        <Transactions id={id} />
      ) : null}

      {showModal && (
        <ConfirmationModal
          title={
            adminDetails?.admin_data?.status === "Active"
              ? "Block User ?"
              : "Unblock User ?"
          }
          message={
            adminDetails?.admin_data?.status === "Active"
              ? "Do you want to block this admin "
              : "Do you want to unblock this admin "
          }
          onClick={() => _blockUser(id)}
          close={() => setShowModal(false)}
        />
      )}
    </div>
  );
}
